// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Subject_buttonContainer__r67l7","addButton":"Subject_addButton__alHnV"};